module.exports = __webpack_public_path__ + "static/media/erm.6d213e65.svg";